import { EmptyState } from '@chopchop-se/ui';
import { HardHat } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from './PageHeader';

/**
 * The placeholder every not-yet-built area route renders.
 *
 * Wave-1 module agents DELETE their area's use of this and render the real page
 * — the route entry and the nav item in `src/areas/<module>/routes.tsx` are
 * already wired, so shipping a page never means touching the router.
 *
 * `titleKey` is a full i18n key including its namespace, e.g.
 * `'common:nav.warehouse.map'`, so the title comes from the SHARED catalog that
 * the module agent owns.
 */
export function UnderConstruction({ titleKey }: { titleKey: string }): ReactNode {
  const { t } = useTranslation(['shell', 'common']);
  return (
    <>
      <PageHeader title={t(titleKey)} />
      <EmptyState
        icon={<HardHat />}
        title={t('shell:underConstruction.title')}
        description={t('shell:underConstruction.description')}
      />
    </>
  );
}
